//메인페이지 데이터 조회
import { useSelector } from 'react-redux';
import { RootState } from '../../modules';

export default function useStatus() {
  const status = useSelector((state: RootState) => state.main);
  return status;
}
